var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon24BlogInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 6.75c.69 0 1.25.56 1.25 1.25v4a1.25 1.25 0 1 1-2.5 0v-4c0-.69.56-1.25 1.25-1.25zM12 7a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 12 7z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0xMiAyMmExMCAxMCAwIDEgMSAwLTIwIDEwIDEwIDAgMCAxIDAgMjB6bTAtMThhOCA4IDAgMSAwIDAgMTYgOCA4IDAgMCAwIDAtMTZ6bTAgNi43NWMuNjkgMCAxLjI1LjU2IDEuMjUgMS4yNXY0YTEuMjUgMS4yNSAwIDEgMS0yLjUgMHYtNGMwLS42OS41Ni0xLjI1IDEuMjUtMS4yNXpNMTIgN2ExLjI1IDEuMjUgMCAxIDAgMCAyLjVBMS4yNSAxLjI1IDAgMCAwIDEyIDd6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4NCjwvc3ZnPg0K";
export { SvgIcon24BlogInfo as ReactComponent };